// Customers Groups State

export default {
  fullGroupsList: [],
  groupsList: [],
  groupInfo: {}
}
